
import {Component, Mixins, Ref} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {VForm} from "@/types";
import GenelIslemFormWizard, {GenelIslemEntity} from "@/components/forms/form-wizard/eicrapro/GenelIslemFormWizard.vue";
import {IExcelDosya, Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import EnumPicker from "@/components/pickers/EnumPicker.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {IAvukatDosya} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";
import IndirilecekEvrakTuruPicker from "@/components/pickers/uyap/IndirilecekEvrakTuruPicker.vue";

@Component({
  components: {IndirilecekEvrakTuruPicker, EnumPicker, GenelIslemFormWizard}
})
export default class EvrakIndirFormWizard extends Mixins(SimpleInputMixin) {
  @Ref('form') readonly form!: VForm;
  @Ref('genel-form') genelForm!: GenelIslemFormWizard;

  localValue: GenelIslemEntity = new GenelIslemEntity();
  valid = false;
  onFly = false;

  stepperHeaders = [
    "Listelenecek Takipler",
    "Takipleri Seç",
    "Evrakları İndir",
    "İşlemler Sıraya Alındı"
  ];

  islemDegerleri = {
    turler: [],
    sonEvrakSayisi: 0
  }

  async createTask() {
    if (this.form.validate()) {
      this.onFly = true;
      let tasks: Array<Task> = [];
      // @ts-ignore
      this.localValue.secilen_takipler.forEach((secilenTakip: IAvukatDosya | IExcelDosya) => {
        let task: Task = new Task()
        task.dosya_esas_no = secilenTakip.dosyaNo;
        task.birim_adi = secilenTakip.birimAdi;
        task.dosya_id = secilenTakip.dosyaId;
        task.birim_id = secilenTakip?.birimId;
        task.uyap_dosya_acilis_tarihi = secilenTakip.dosyaAcilisTarihi ? new Date(this.$uyapHelper.formatDate(secilenTakip.dosyaAcilisTarihi)).toString() : "";
        task.task_type_id = TaskTuru.evrak_indir;
        task.data = this.islemDegerleri;
        tasks.push(task);
      });
      let res = await this.$store.dispatch('postTasks', tasks);
      if (this.$store.getters.getAutoPlay)
        await this.$router.push(ProgramPaths.eicrapro + '/evrak-indir-detay/' + res.data.id);
      else
        await this.$router.push(ProgramPaths.eicrapro + '/islemler');
      // this.genelForm.activeStep++;
      // this.onFly = false;
    }
  }
}
